import React from 'react';
import { Modal, Paper } from '@mui/material';
import EditReadinessProblemLayout from '../layouts/EditReadinessProblemLayout';
import {Operator} from "../../../classes/Operator";
import {OperatorReadinessProblem} from "../../../classes/OperatorReadinessProblem";

function NewReadinessProblemModal(props: {
    operatorData: Operator,
    isOpen: boolean,
    onClose: Function,
    onSubmit: Function
}) {

    const newProblem = new OperatorReadinessProblem()
    newProblem.operatorId = props.operatorData.id!

    return (
        <Modal
            open={props.isOpen}
            onClose={() => props.onClose()}
        >
            <Paper
                sx={{
                    position: 'absolute',
                    width: '600px',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    padding: 2
                }}
            >
                <EditReadinessProblemLayout
                    title="New Readiness Problem"
                    initData={newProblem}
                    onCancel={props.onClose}
                    onSubmit={props.onSubmit}
                />
            </Paper>
        </Modal>
    );
}

export default NewReadinessProblemModal;